import { render, staticRenderFns } from "./YearlyReport.vue?vue&type=template&id=48797c72&"
import script from "./YearlyReport.vue?vue&type=script&lang=js&"
export * from "./YearlyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports